import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTable, faTrash, faClone } from '@fortawesome/free-solid-svg-icons'
import { Popconfirm, Table, Row, Col, Input, Button, Tooltip, Modal, message, Tag } from 'antd'
import AgiliteUtils from 'agilite-utils'
import { SyncOutlined } from '@ant-design/icons'
import { columnTemplates } from '../../utils/templates'
import MemoryStore from '../../utils/memory-store'

import '../reusables-views.css'
import Enums from '../../utils/enums'

class ListViewNestedTree extends React.Component {
  constructor(props) {
    super(props)

    this.appId = props.appId

    this.state = {
      viewData: this.props.viewData,
      searchFilter: this.props.searchFilter,
      viewColumns: this.props.viewColumns,
      loading: false,
      valuesModalVisible: false,
      values: [],
      columns: this.props.viewColumns,
      theme: this.props.theme
    }

    this.fetchAllData = this.fetchAllData.bind(this)
    this.generateViewHeader = this.generateViewHeader.bind(this)
    this.createProfile = this.createProfile.bind(this)
    this.editProfile = this.editProfile.bind(this)
    this.deleteProfile = this.deleteProfile.bind(this)
    this.createCopy = this.createCopy.bind(this)
    this.updateViewColumns = this.updateViewColumns.bind(this)
    this.updateNestedViewColumns = this.updateNestedViewColumns.bind(this)
    this.expandedRowRender = this.expandedRowRender.bind(this)
    this.expandedRowRender2 = this.expandedRowRender2.bind(this)
  }

  UNSAFE_componentWillMount() {
    this.fetchAllData()
  }

  fetchAllData() {
    this.setState({
      loading: true
    })
    this.props.fetchAllData(this.props.appId, (success, error) => {
      if (success) {
        this.updateViewColumns(this.props)
        this.updateNestedViewColumns(this.props)
        this.setState({ loading: false })
      } else {
        message.error(error)
        this.setState({ loading: false })
      }
    })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.appId !== nextProps.appId) {
      return null
    }

    this.updateViewColumns(nextProps)
    this.updateNestedViewColumns(nextProps)

    this.setState({
      viewData: nextProps.viewData,
      searchFilter: nextProps.searchFilter,
      viewColumns: nextProps.viewColumns
    })
  }

  updateViewColumns(props) {
    // Add Intelligence to relevant Columns
    const columns = props.viewColumns

    for (const x in columns) {
      // Check which column needs to be grouped
      if (columns[x].groupable) {
        for (const propName in props) {
          if (propName === columns[x].key + 'Filter') {
            columns[x].filters = props[propName]
          }
        }
      }
    }

    this.setState({ columns })
  }

  updateNestedViewColumns(props) {
    // Add Intelligence to relevant Columns
    const columns = props.viewColumnsNested

    for (const x in columns) {
      if (columns[x].isActions) {
        // eslint-disable-next-line
        columns[x].render = (text, record) => {
          return (
            <div style={{ minWidth: 50 }}>
              {/* Show Values Modal */}
              {columns[x].actionTypes.indexOf('showValues') > -1 ? (
                <div
                  className={
                    process.env.NODE_ENV === 'development' ? 'row-icon row-icon-show' : 'row-icon row-icon-hide'
                  }
                >
                  {/* eslint-disable-next-line */}
                  <a
                    onClick={() => {
                      this.setState({ valuesModalVisible: true })
                      this.formatValues(record.values)
                    }}
                  >
                    <FontAwesomeIcon icon={faTable} style={{ marginLeft: 10 }} />
                  </a>
                </div>
              ) : null}
            </div>
          )
        }
      }
    }
  }

  formatValues(values) {
    values.map((entry) => {
      entry.rowKey = AgiliteUtils.uuidv1()
      return null
    })

    this.setState({ values })
  }

  createProfile() {
    const tmpThis = this

    tmpThis.props.createProfile(tmpThis.props.appId, function (result) {
      if (result) {
        // Setup Content property and Add Tab
        result.content = <result.content />
        tmpThis.props.addTab(result)
      }
    })
  }

  editProfile(recordId) {
    const tmpThis = this

    tmpThis.props.editProfile(tmpThis.props.appId, recordId, this.props.viewData, function (result) {
      if (result) {
        // Setup Content property and Add Tab
        result.content = <result.content />
        tmpThis.props.addTab(result)
      }
    })
  }

  deleteProfile(recordId) {
    if (this.props.appId === Enums.APP_IDS.BPM) {
      Modal.confirm({
        title: 'Delete Linked Numbering Profile',
        content:
          'Do you want to delete the Numbering Profile linked to this BPM Profile? Note that it might be used by multiple processes.',
        okText: Enums.VALUES_STRINGS.YES,
        cancelText: Enums.VALUES_STRINGS.NO,
        onOk: () => {
          this.deleteProfileExtended(recordId, true)
        },
        onCancel: () => {
          this.deleteProfileExtended(recordId, false)
        }
      })
    } else {
      this.deleteProfileExtended(recordId, false)
    }
  }

  deleteProfileExtended(recordId, deleteNumberProfile) {
    this.props.deleteProfile(
      this.props.appId,
      recordId,
      this.props.state,
      (err) => {
        if (err) {
          message.error(err)
        }
      },
      deleteNumberProfile
    )
  }

  createCopy(recordData) {
    const tmpThis = this
    tmpThis.props.onCreateCopy(recordData, function (result) {
      if (result) {
        // Setup Content property and Add Tab
        result.content = <result.content />
        tmpThis.props.addTab(result)
      }
    })
  }

  generateViewHeader() {
    return (
      <div>
        <Row type='flex'>
          <Col xs={7} sm={5} md={4} lg={4} xl={3} xxl={2} style={{ textAlign: 'left' }}>
            <Button
              disabled={MemoryStore.userProfile.teamPrivileges[this.props.appId] === 'Reader' ? true : false}
              style={{ backgroundColor: '#67AD5B', color: 'white' }}
              onClick={(e) => {
                e.preventDefault()
                this.createProfile()
              }}
            >
              Create New
            </Button>
          </Col>
          <Col xs={13} sm={14} md={16} lg={16} xl={19} xxl={20}>
            <Input
              name='search'
              placeholder={`Search ${this.props.viewTitle}...`}
              defaultValue={this.props.searchFilter}
              onChange={(e) => {
                this.props.setSearchFilter(e.target.value)
              }}
            />
          </Col>
          <Col xs={4} sm={4} md={4} lg={4} xl={2} xxl={2}>
            <Tooltip title='Refresh View Data'>
              <Button
                name='refresh'
                type='default'
                onClick={(e) => {
                  e.preventDefault()
                  this.fetchAllData()
                }}
              >
                <SyncOutlined
                  style={{ fontSize: 20, fontWeight: 'bolder', color: '#67AD5B' }}
                  spin={this.state.loading}
                />
              </Button>
            </Tooltip>
          </Col>
        </Row>
      </div>
    )
  }

  expandedRowRender(entry) {
    const tmpEntry = entry.data ? entry.data[this.props.nestedPropName] : entry[this.props.nestedPropName]
    const tmpViewColumns = this.props.viewColumnsNested

    if (tmpEntry && tmpEntry.length !== 0) {
      tmpEntry.map((entry) => {
        entry.isActiveDescription = entry.isActive ? 'Yes' : 'No'
        entry.rowKey = AgiliteUtils.uuidv1()
        return null
      })
    }

    for (const x in tmpViewColumns) {
      if (tmpViewColumns[x].copyKey) {
        tmpViewColumns[x].render = (text) => {
          return {
            props: {
              style: { cursor: 'copy' }
            },
            children: <div>{text}</div>
          }
        }

        tmpViewColumns[x].onCell = (record) => {
          return {
            onClick: (e) => {
              navigator.clipboard.writeText(record.key)
              message.info('Value copied to clipboard')
            }
          }
        }
      }
    }

    return (
      <Table
        columns={tmpViewColumns}
        dataSource={tmpEntry}
        size='small'
        pagination={false}
        rowKey={(record) => record.rowKey}
        expandedRowRender={this.appId === 'tierstructures' ? this.expandedRowRender : this.expandedRowRender2}
      />
    )
  }

  expandedRowRender2(entry) {
    const tmpEntry = entry.data ? entry.data[this.props.nestedPropName2] : entry[this.props.nestedPropName2]
    const tmpViewColumns = JSON.parse(JSON.stringify(this.props.viewColumnsNested2))

    if (tmpEntry && tmpEntry.length !== 0) {
      tmpEntry.map((entry) => {
        entry.isActiveDescription = entry.isActive ? 'Yes' : 'No'
        entry.rowKey = AgiliteUtils.uuidv1()
        return null
      })
    }

    for (const x in tmpViewColumns) {
      if (tmpViewColumns[x].copyKey) {
        tmpViewColumns[x].render = (text) => {
          return {
            props: {
              style: { cursor: 'copy' }
            },
            children: <div>{text}</div>
          }
        }

        tmpViewColumns[x].onCell = (record) => {
          return {
            onClick: (e) => {
              navigator.clipboard.writeText(record.key)
              message.info('Value copied to clipboard')
            }
          }
        }
      }
    }

    return (
      <Table
        columns={tmpViewColumns}
        dataSource={tmpEntry}
        size='small'
        pagination={false}
        rowKey={(record) => record.rowKey}
      />
    )
  }

  render() {
    const columns = []
    const tmpThis = this
    let tmpObj = {}
    let data = null

    for (const x in this.state.columns) {
      tmpObj = JSON.parse(JSON.stringify(this.state.columns[x]))

      // Add render function to all columns at first
      // The element rendered here will ensure that the content does not exceed width
      tmpObj.render = (text) => {
        return <div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}>{text}</div>
      }

      // Show Solutions
      if (this.state.columns[x].key === 'solutions') {
        tmpObj.render = (text, record, index) => {
          if (record.data.solutions) {
            return record.data.solutions.map((entry) => {
              return (
                <Tag style={{ margin: 2 }} color='geekblue' key={AgiliteUtils.uuidv1()}>
                  {entry}
                </Tag>
              )
            })
          }
        }
      }

      // Check which column is used to edit the record and copy the key
      if (this.state.columns[x].editRecord && this.state.columns[x].copyKey) {
        tmpObj.render = (text, record) => {
          return {
            props: {
              style: { cursor: 'copy' }
            },
            children: (
              <div>
                <a onClick={() => this.editProfile(record._id)}>{text}</a>
              </div>
            )
          }
        }

        tmpObj.onCell = (record) => {
          return {
            onClick: () => {
              navigator.clipboard.writeText(record.data ? record.data.key : record.key)
              message.info('Value copied to clipboard')
            }
          }
        }
      } else if (this.state.columns[x].editRecord) {
        tmpObj.render = (text, record) => {
          return (
            <div>
              <a onClick={() => this.editProfile(record._id)}>{text}</a>
            </div>
          )
        }
      } else if (this.state.columns[x].copyKey) {
        tmpObj.render = (text) => {
          return {
            props: {
              style: { cursor: 'copy' }
            },
            children: <div>{text}</div>
          }
        }

        tmpObj.onCell = (record) => {
          return {
            onClick: () => {
              navigator.clipboard.writeText(record.data ? record.data.key : record.key)
              message.info('Value copied to clipboard')
            }
          }
        }
      }

      if (this.state.columns[x].groupable) {
        // eslint-disable-next-line
        tmpObj.onFilter = function (value, record) {
          data = record.data ? record.data : record
          return data[tmpThis.state.columns[x].key].toLowerCase() === value.toLowerCase()
        }
      }

      if (this.state.columns[x].isActions) {
        // eslint-disable-next-line
        tmpObj.render = (text, record) => {
          return (
            <div style={{ minWidth: 50 }}>
              {/* //First Delete Action */}
              {this.state.columns[x].actionTypes.indexOf('delete') > -1 &&
              MemoryStore.userProfile.teamPrivileges[this.props.appId] !== 'Reader' ? (
                <div
                  className={
                    process.env.NODE_ENV === 'development' ? 'row-icon row-icon-show' : 'row-icon row-icon-hide'
                  }
                >
                  <Popconfirm
                    title='Are you sure delete this Profile?'
                    onConfirm={() => {
                      this.deleteProfile(record._id)
                    }}
                    okText='Yes'
                    cancelText='No'
                  >
                    {/* eslint-disable-next-line */}
                    <a title='Delete Profile'>
                      <FontAwesomeIcon
                        icon={faTrash}
                        style={{ color: tmpThis.state.theme.dangerColor, marginRight: 10 }}
                      />
                    </a>
                  </Popconfirm>
                </div>
              ) : null}
              {/* Create Copy  */}
              {this.state.columns[x].actionTypes.indexOf('create-copy') > -1 ? (
                <div
                  className={
                    process.env.NODE_ENV === 'development' ? 'row-icon row-icon-show' : 'row-icon row-icon-hide'
                  }
                  style={{ marginLeft: 10, marginRight: 10 }}
                >
                  {/* eslint-disable-next-line */}
                  <a>
                    <FontAwesomeIcon
                      icon={faClone}
                      onClick={() => this.createCopy(record.data)}
                      style={{ color: tmpThis.state.theme.primaryLight }}
                    />
                  </a>
                </div>
              ) : null}
              {/* Show Values Modal */}
              {this.state.columns[x].actionTypes.indexOf('showValues') > -1 ? (
                <div
                  className={
                    process.env.NODE_ENV === 'development' ? 'row-icon row-icon-show' : 'row-icon row-icon-hide'
                  }
                >
                  {/* eslint-disable-next-line */}
                  <a
                    title='Show Values'
                    onClick={() => {
                      this.setState({ valuesModalVisible: true })
                      this.formatValues(record.data.values)
                    }}
                  >
                    <FontAwesomeIcon icon={faTable} style={{ marginLeft: 10 }} />
                  </a>
                </div>
              ) : null}
            </div>
          )
        }
      }

      columns.push(tmpObj)
    }

    return (
      <Row type='flex' justify='center'>
        <Col xs={23}>
          <Table
            loading={this.state.loading}
            expandedRowRender={this.expandedRowRender}
            className='agilite-nested-root-table'
            columns={columns}
            dataSource={this.state.viewData}
            childrenColumnName={this.props.childrenColumnName}
            showHeader
            bordered
            title={this.generateViewHeader}
            size='middle'
            pagination={false}
            rowKey={(record) => record.data.key}
          />
          <Modal
            closable={false}
            onOk={() => this.setState({ valuesModalVisible: false })}
            visible={this.state.valuesModalVisible}
            destroyOnClose
            maskClosable
            cancelButtonProps={{ hidden: true }}
            width={1050}
          >
            <Table
              dataSource={this.state.values}
              columns={columnTemplates.tier_values}
              pagination={false}
              bordered
              style={{ margin: 20 }}
              rowKey={(record) => record.rowKey}
            />
          </Modal>
        </Col>
      </Row>
    )
  }
}

export default ListViewNestedTree
